<loading-indicator [running]="isLoading" />

@if (!isLoading) {
	<h2>
		{{ "tasks.notCompleted" | translate }}
		<span class="right">{{ shift?.start | date: "HH:mm" }} - {{ shift?.end | date: "HH:mm" }}</span>
	</h2>
	@if (!isEmpty) {
		<ic-task-swipe-list [shift]="shift" [tasks]="tasks" (selectTask)="selectTask.emit($event)" />
	}
	<div class="center">
		<div class="messages">
			@if (isEmpty) {
				<p data-test="no-planned-tasks">{{ "tasks.empty_state" | translate }}<br /></p>
			}
			@if (!isEmpty && tasks?.uncompleted?.length === 0) {
				<p data-test="empty-uncompleted-tasks-list">{{ "tasks.empty_notCompleted" | translate }}<br /></p>
			}
			<p *userHasPermission="['MEDAPP.CARE.ADMINISTER_CARE']">{{ "tasks.task_unplanned_add" | translate }}</p>
		</div>
		<button *userHasPermission="['MEDAPP.CARE.ADMINISTER_CARE']" data-test="create-task" (click)="create.emit()">
			<i class="fa fa-plus"></i>
			<span>{{ "tasks.task_unplanned_add_text" | translate }}</span>
		</button>
	</div>

	@if (!isEmpty) {
		<h3>{{ "tasks.completed" | translate }}</h3>
		@if (tasks.completed.length === 0) {
			<li class="empty">
				{{ "tasks.empty_completed" | translate }}
			</li>
		}
		@if (tasks.completed.length > 0) {
			<ul class="list">
				@for (task of tasks.completed; track task) {
					<li data-test="completed-tasks" (click)="selectTask.emit(task)">
						<ic-task-item
							data-test="completed-task"
							[class.unplanned]="task.unplanned"
							[current]="shift.id === task.shift"
							[enabled]="task.hasUserHandlePermission && canUpdateTask(task)"
							[task]="task"
						/>
					</li>
				}
			</ul>
		}
	}

	@if (activities && activities.length >= 1) {
		<h3>{{ "tasks.activities" | translate }}</h3>
		<ic-activity-list [activities]="activities" />
	}
}
<katz-icons />
